import * as types from './actionTypes';
import loading from './loading';
import loaded from './loaded';
import brokerSaveDesign from '../api/designBuilder/brokerSaveDesign';
import LinkEstimateContext from '../helpers/linkEstimateContext';
import config from '../helpers/config';
import AnalyticsConstants from '../analytics/constants';
import {
  createAndSendButtonSubmissionEventWithEventName,
} from '../analytics/commonAnalytics';
import * as thdUser from '../../common/thdUserInfo';
import { sites } from '../helpers/globalVariables';

export default designId => (dispatch, getState) => {
  if (config.repId() !== null) return Promise.resolve('Take No Action when Rep is logged in');

  if (thdUser.getLoggedInUserInfo().identityId === null) return Promise.resolve('Take No Action when User is not logged in');

  dispatch(loading());

  const context = new LinkEstimateContext(designId);

  const { isLinked, name } = getState().estimateBuilder.entities.estimates.byId[designId];

  return context.saveToMyAccount()
    .then(() => {
      dispatch({
        type: types.SAVE_TO_MY_ACCOUNT_SUCCESS,
        payload: {
          designId,
        },
      });

      if (!isLinked) {
        createAndSendButtonSubmissionEventWithEventName(
          window.globalConfig.siteId,
          AnalyticsConstants.EventNames.DesignSave,
        );
      }
      dispatch(loaded());

      const userInfo = thdUser.getLoggedInUserInfo();
      if (config.siteId === sites.theHomeDepot && userInfo && userInfo.identityId) {
        brokerSaveDesign(userInfo.identityId, designId, name);
      }
    })
    .catch((ex) => {
      dispatch(loaded());
      throw ex;
    });
};
